/**
 * package: com.inq.stage
 * class: ViewportMgrImplPhoneWindows 
 * @extends com.inq.stage.ViewportMgrImplPhoneAndroid 
 * @constructor
 */
com.inq.stage.ViewportMgrImplPhoneWindows = function() {
	com.inq.stage.ViewportMgrImplPhoneAndroid.call(this);
//	com.inq.stage.ViewportMgrImplPhoneWindows.__super__.call(this);
};
/* specify hierary; its parent is com.inq.stage.ViewportMgrImplPhone */
$hxClasses.extend(
			com.inq.stage.ViewportMgrImplPhoneAndroid, 				/* super */
			com.inq.stage.ViewportMgrImplPhoneWindows, 			/* this class */
			'com.inq.stage.ViewportMgrImplPhoneWindows');		/* class as a string */

/**
 * addCssChatAction = adds style tag that fixes the touch action removing the pinch zoom guesture
 *		also adds meta tag to force "edge" compatibilty.
 * @private
 * @return {void} 
 */
com.inq.stage.ViewportMgrImplPhoneWindows.prototype.addCssChatAction = function() {
	try {
		var head = document.getElementsByTagName("head")[0];
		var metaTagEdge = document.createElement("Meta");
		metaTagEdge.setAttribute("http-equiv","X-UA-Compatible");
		metaTagEdge.setAttribute("content","IE=edge");
		metaTagEdge.id = "metaTagEdge";
		head.insertBefore(metaTagEdge, head.firstChild);
 
		var styleText = 
			'html, * {  touch-action: pan-y pan-x !important;    -ms-touch-action: pan-y pan-x !important;}' +
			' body {  touch-action: none !important;    -ms-touch-action: none !important;}' +
			' .tcChat {	touch-action: pan-y pan-x !important;	-ms-touch-action: pan-y pan-x !important;}';

		var cssAdjustChatAction = document.getElementById("tcAjustChatAction");
		if (cssAdjustChatAction != null) {
			cssAdjustChatAction.parentNode.removeChild(cssAdjustChatAction);
		}
			
		var msViewportStyle = document.createElement("style");
		msViewportStyle.id = "tcAjustChatAction";
			
		msViewportStyle.appendChild(document.createTextNode(styleText));

		head.appendChild(msViewportStyle);
		window.top.document.body.style["-ms-touch-action"] = "none";
	} catch (er) {
		alert("Error in function addCssChatAction: " + er);
	}
};
	
/**
 * removeCssChatAction = removes style tag that fixes the touch action removing the pinch zoom guesture
 *		also removes meta tag to force "edge" compatibilty.
 * @private
 * @return {void}
 */
com.inq.stage.ViewportMgrImplPhoneWindows.prototype.removeCssChatAction = function() {
	var cssAdjustChatAction = document.getElementById("tcAjustChatAction");
	if (cssAdjustChatAction != null) {
		cssAdjustChatAction.parentNode.removeChild(cssAdjustChatAction);
	}
	
	var metaTagEdge = document.getElementById("metaTagEdge");
	if (metaTagEdge != null) {
		metaTagEdge.parentNode.removeChild(metaTagEdge);
	}
	window.top.document.body.style["-ms-touch-action"] = "";
};


/**
 * show
 *
 * This sets viewport meta tag content value to an optimized value to open a chat window.
 * A viewport meta tag is created if a client window does not have it.
  * Added logic to:
 *    1) add the meta tag Form none-compatibilty mode
 *    2) add the style tag For fixing pinch guesture
 *
 * @public
 * @override 
 * @this com.inq.stage.ViewportMgrImplPhoneWindows
 * @return {void}
 */
com.inq.stage.ViewportMgrImplPhoneWindows.prototype.show = function() {
//	com.inq.stage.ViewportMgrImplPhoneWindows.__super__.prototype.show.call(this);
	com.inq.stage.ViewportMgrImplPhoneAndroid.prototype.show.call(this);

	this.addCssChatAction();
};


/**
 * hide
 *
 * This resets viewport meta tag content value to its original value from client window.
 * Added logic to:
 *    1) remove the meta tag Form none-compatibilty mode
 *    2) remove the style tag For fixing pinch guesture
 *
 * @public
 * @override
 * @this com.inq.stage.ViewportMgrImplPhoneWindows
 * @return {void}
 */
com.inq.stage.ViewportMgrImplPhoneWindows.prototype.hide = function() {
//	com.inq.stage.ViewportMgrImplPhoneWindows.__super__.prototype.hide.call(this);
	com.inq.stage.ViewportMgrImplPhoneAndroid.prototype.hide.call(this);
	this.removeCssChatAction();
};


/**
 * fixPositioning
 *
 * $type TFun([],TEnum(Void,[]))
 * @override
 * @private
 * @this com.inq.stage.ViewportMgrImplPhone
 * @return {void}
 */
com.inq.stage.ViewportMgrImplPhoneWindows.prototype.fixPositioning = function() {
	com.inq.stage.ViewportMgrImplMobile.prototype.fixPositioning.call(this); // Calling super.super.fixPositioning here. Hacky, but compact.

	/* We want to hide the location bar on phones. So we must increase the minimum height to guarantee
	 * that we can scroll down one pixel to hide the location bar.
	 */
	if (this.clientWindow.pageYOffset == 0) {
		this.clientWindow.scrollTo(this.clientWindow.pageXOffset, 1);
	}
};

